module.exports = __webpack_public_path__ + "static/media/logo-vendora-negative-2.2ab7bf4d.svg";